import dynamic from 'next/dynamic';
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import { LoaderPage } from 'ht-styleguide';
import { PAGE_TYPE_FAQ } from '@constants/pages';

const ClientFaqPage = dynamic(
  () => import('@scenes/FaqPage'), // adjust path as needed
  {
    ssr: false,
    loading: () => <LoaderPage />,
  },
);

// Main page component
function FaqPage(props: any) {
  return <ClientFaqPage {...props} />;
}

FaqPage.pageAttributes = { page: PAGE_TYPE_FAQ };
FaqPage.Layout = getLayout({ promo: true, footer: true, chat: true });

export default FaqPage;
